import {Types} from './Types';
export default Types;